// QA check with HW

import {RestApiService} from '../../../rest-api.service';
import {Observable} from "rxjs";
import {BaseCollectionModel, SearchModel} from '@yasc/yasc-material-components';
import {DeviceDataCsvImportRequest, DeviceDataRequest, DeviceDataResponse,} from '../../../../contracts/v0/contracting/device-data.contracts';
import {ApiV0Contracting} from '../api.v0.contracting';

export class ApiV0DeviceData {
    segment: string;

    constructor(v0: ApiV0Contracting, private rest: RestApiService) {
        this.segment = v0.segment + '/deviceData';
    }

    list(): Observable<BaseCollectionModel<DeviceDataResponse>> {
        return this.rest.get<BaseCollectionModel<DeviceDataResponse>>(`${this.segment}/list`, DeviceDataResponse)
    }

    search(searchModel?: SearchModel): Observable<BaseCollectionModel<DeviceDataResponse>> {
        return this.rest.post<SearchModel, BaseCollectionModel<DeviceDataResponse>>(`${this.segment}/search`, DeviceDataResponse, searchModel)
    }

    detail(guid: string): Observable<DeviceDataResponse> {
        return this.rest.get(`${this.segment}/details/${guid}`, DeviceDataResponse)
    }

    create(createRequest: DeviceDataRequest) {
        return this.rest.post<DeviceDataRequest, DeviceDataResponse>(`${this.segment}/create`, DeviceDataResponse, createRequest)
    }

    update(updateRequest: DeviceDataRequest) {
        return this.rest.patch<DeviceDataRequest, DeviceDataResponse>(`${this.segment}/update`, DeviceDataResponse, updateRequest)
    }

    delete(guid: string) {
        return this.rest.delete<void>(`${this.segment}/delete/${guid}`)
    }

    importCsvData(data: DeviceDataCsvImportRequest): Observable<BaseCollectionModel<DeviceDataResponse>> {
        return this.rest.post<DeviceDataCsvImportRequest, BaseCollectionModel<DeviceDataResponse>>(
            `${this.segment}/import/csv`,
            DeviceDataResponse,
            data
        )
    }

    importExcelData(data: DeviceDataCsvImportRequest): Observable<BaseCollectionModel<DeviceDataResponse>> {
        return this.rest.post<DeviceDataCsvImportRequest, BaseCollectionModel<DeviceDataResponse>>(
            `${this.segment}/import/excel`,
            DeviceDataResponse,
            data
        )
    }

    cpuArchitectureSelectionList(): Observable<BaseCollectionModel<string>> {
        return this.rest.get<BaseCollectionModel<string>>(`${this.segment}/cpuArchitectureSelectionList`)
    }

    kernelTypeSelectionList(): Observable<BaseCollectionModel<string>> {
        return this.rest.get<BaseCollectionModel<string>>(`${this.segment}/kernelTypeSelectionList`)
    }

    productTypeSelectionList(): Observable<BaseCollectionModel<string>> {
        return this.rest.get<BaseCollectionModel<string>>(`${this.segment}/productTypeSelectionList`)
    }
}

